
/**
 * If the teacher has a submitted photo that's awaiting screening, we should
 * modify the appearance of the upload-a-new-photo tool a bit.
 */
export const markPhotoPendingScreening = function markPhotoPendingScreening() {
    $('.js-classroom-photo-check')
        .removeClass('upload')
        // We're running some Optimizely experiments that replace the contents
        // of .classroom-photo in TPC right now, so this doesn't work in TPC.
        // We can't just remove .classroom-photo here, though, because the
        // page CSS depends on it.
        .addClass('pending-screening')
        .html('<p><em>Your new classroom photo has been submitted for approval. Once a staff member approves it, it will be visible to all site visitors.</em></p>')
        .css({
            'background-image': 'url(' + baseCacheURL + 'images/classroom/fallback-classroom-300.png)',
            'pointer-events': 'none',
        });
    $('.add-classroom-photo').remove()
};
